export default "__VITE_ASSET__DKvffpat__"